import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useCallbackObservable, useObservable } from 'react-use-observable';

import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import eduzzAccountsService from 'v2/services/eduzzAccount';
import { financialStatementService } from 'v2/services/financialStatement/statement';

import ValueCard from '../ValueCard';

function TotalCard() {
  const [loadingTotalAvailable, setLoadingTotalAvailable] = useState(true);
  const [totalAvailableValue, setTotalAvailableValue] = useState(null);
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);

  const [loadTotalAvailable] = useCallbackObservable(() => {
    setLoadingTotalAvailable(true);

    return financialStatementService.getTotalAvailable().pipe(
      tap(({ data }) => {
        setTotalAvailableValue(user?.crossborder ? data.total_origin : data.total);
        setLoadingTotalAvailable(false);
      }),
      catchError(error => {
        toast.error(error);
        setLoadingTotalAvailable(false);
        return of(true);
      })
    );
  }, []);

  useEffect(() => {
    loadTotalAvailable();
  }, [loadTotalAvailable]);

  return (
    <ValueCard
      id='total-card'
      title='Saldo total'
      hint='Soma do saldo disponível para transferência mais lançamentos futuros'
      isLoading={loadingTotalAvailable}
      value={totalAvailableValue}
    />
  );
}

export default TotalCard;
